const axios = require('axios')

class StreamerTransport {

    static async init (props) {
        if (!props) {
            console.error('could not init streamer transport')
        }
        
        if (StreamerTransport.initialised) {
            return
        }

        StreamerTransport.endpoint = props.endpoint

        StreamerTransport.initialised = true

        return true
    }

    static async push (streamName, events) {
        try {
            await axios({
                url: StreamerTransport.endpoint,
                method: 'PUT',
                data: {
                    DeliveryStreamName: streamName,
                    Records: events.map((event) => {
                        return {
                            Data: Buffer.from(`${event.serialise()}\n`).toString('base64')
                        }
                    })
                }
            })
        } catch (e) {
            console.error('failed to push events', e)
        }
    }
}

module.exports = StreamerTransport
